import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import { AuthGate } from './auth/AuthGate'
import { stashForRedirect } from './auth/carry'
import { setBeforeRedirect } from './auth/msal'
import { captureLaunches, waitForLaunch } from './files/fileAccess'
import './theme.css'

// Before anything else: take a double-clicked PDF off the launch queue, so it
// is in hand if sign-in has to leave the page.
captureLaunches()

setBeforeRedirect(async () => {
  // Launched via the .pdf file handler: give the launch a moment to arrive
  // before the page goes, or it is lost.
  if (window.location.pathname === '/open') await waitForLaunch(2000)
  await stashForRedirect()
})

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root element')

createRoot(container).render(
  <StrictMode>
    <AuthGate>{(resume) => <App resume={resume} />}</AuthGate>
  </StrictMode>,
)
